export const unescapeHtml = (target: string) => {
	if (!target) {
		return '';
	}
	const patterns = {
		'&lt;': '<',
		'&gt;': '>',
		'&amp;': '&',
		'&quot;': '"',
		'&#x27;': "'",
		'&#x60;': '`',
	};
	return target.replace(/&(lt|gt|amp|quot|#x27|#x60);/g, function (match) {
		return patterns[match];
	});
};
